import { Component, ChangeDetectionStrategy, inject, Input } from '@angular/core';
import { TestCaseRunResult } from '../python-exercise';
import { TranslocoService } from '@ngneat/transloco';
import { registerTranslationsManuallyStatic } from '@skyeng/libs/shared/i18n';
import entranslation from './translation/en.json';
import rutranslation from './translation/ru.json';

@Component({
  selector: 'skypro-python-exercise-test-case-description',
  templateUrl: './python-exercise-test-case-description.component.html',
  styleUrls: ['./python-exercise-test-case-description.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PythonExerciseTestCaseDescriptionComponent {
  @Input() result: TestCaseRunResult;

  private translocoService = inject(TranslocoService);

  constructor() {
    registerTranslationsManuallyStatic('skyproLibsBlocksPythonExerciseTestCase', this.translocoService, {
      en: entranslation,
      ru: rutranslation,
    });
  }
}
